import React from 'react';

export interface AuthSelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface AuthSelectFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  options: AuthSelectOption[];
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  hint?: string;
  error?: string;
}

export function AuthSelectField({
  id,
  label,
  value,
  onChange,
  options,
  placeholder = 'Select an option',
  required = false,
  disabled = false,
  hint,
  error,
}: AuthSelectFieldProps) {
  return (
    <div className="auth-field">
      <label htmlFor={id} className="auth-field__label">
        {label}
        {required ? <span className="req">*</span> : null}
      </label>
      <select
        id={id}
        className="auth-field__select"
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      {hint ? <p className="auth-field__hint">{hint}</p> : null}
      {error ? <p className="auth-field__error">{error}</p> : null}
    </div>
  );
}

export default AuthSelectField;
